let level = 2000;
let literalLevel = process.env.DEFAULT_LEVEL;
let initializedLevel = false;

type User = {
    id: string | null;
    name: string | null;
    image: string | null;
} | undefined

export enum LoggerTopic {
    "CRONJOB",
    "DEFAULT"
}

abstract class Logger {
    static INITLEVEL() {
        Logger.SETLEVEL(process.env.DEFAULT_LEVEL || "WARN");
        initializedLevel = true;
    }

    static SETLEVEL(status: string) {
        literalLevel = status.toUpperCase();
        switch (status.toLowerCase()) {
            case "trace":
                level = 1000;
                break;
            case "debug":
                level = 2000;
                break;
            case "warn":
                level = 3000;
                break;
            case "info":
                level = 4000;
                break;
            case "error":
                level = 5000;
                break;
        }
    }

    static GETLEVEL() {
        if (!initializedLevel) {
            Logger.INITLEVEL();
        }
        return literalLevel;
    }

    static WARN(body: string | object, user: User | null = null, topic: LoggerTopic = LoggerTopic.DEFAULT) {
        Logger.GETLEVEL();
        if (level <= 3000) {
            this.LOG("warn", body.toString(), user, topic)
        }
    }

    static ERROR(body: string | object, user: User | null = null, topic: LoggerTopic = LoggerTopic.DEFAULT) {
        Logger.GETLEVEL();
        if (level <= 5000) {
            this.LOG("error", body.toString(), user, topic)
        }
    }

    static INFO(body: string | object, user: User | null = null, topic: LoggerTopic = LoggerTopic.DEFAULT) {
        Logger.GETLEVEL();
        if (level <= 4000) {
            this.LOG("info", body.toString(), user, topic)
        }
    }

    static DEBUG(body: string | object, user: User | null = null, topic: LoggerTopic = LoggerTopic.DEFAULT) {
        Logger.GETLEVEL();
        if (level <= 2000) {
            this.LOG("debug", body.toString(), user, topic)
        }
    }

    static TRACE(body: string | object, user: User | null = null, topic: LoggerTopic = LoggerTopic.DEFAULT) {
        Logger.GETLEVEL();
        if (level <= 1000) {
            this.LOG("trace", body.toString(), user, topic)
        }
    }

    static LOG(level: string, body: string | object, user: User | null, topic: LoggerTopic) {
        console.log(
            JSON.stringify({
                level: level,
                message: typeof body === "string" ? body : JSON.stringify(body),
                topic: topic,
                userId: user?.id || "anonymous",
                timestamp: new Date().toISOString(),
            })
        );
    }

    static LOGWITHLEVEL(body: string | object, user: User | null = null, level: string, topic: LoggerTopic = LoggerTopic.DEFAULT) {
        switch (level.toLowerCase()) {
            case "trace":
                Logger.TRACE(body, user, topic);
                break;
            case "debug":
                Logger.DEBUG(body, user, topic);
                break;
            case "warn":
                Logger.WARN(body, user, topic);
                break;
            case "error":
                Logger.ERROR(body, user, topic);
                break;
            default:
                Logger.INFO(body, user, topic);
        }
    }
}

export default Logger;